import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { ProjectStatusesEnum } from '@shared/enums/project-statuses.enum';

export const StatusesTitles = {
  [ProjectStatusesEnum.InProgress]: marker('In progress'),
  [ProjectStatusesEnum.Finished]: marker('Finished'),
  [ProjectStatusesEnum.BehindSchedule]: marker('Behind Schedule'),
  [ProjectStatusesEnum.OverBudget]: marker('Over budget')
};
